import React, { useEffect } from 'react';

// Hooks
import { useSubscriptionTracking } from 'Shared/tracking/use-subscription-tracking';
import { useApp } from 'Shared/utils/hooks/use-app';

// Types
import { Feature } from 'Shared/types/Organization.type';
import { Illustrations } from 'Wpds/components/illustration';

// Components
import { WpButton } from 'Wpds/components/button';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

import './FreePlanGoalContent.scss';

const FreePlanGoalsContent = () => {
  const { intercomContactSalesEventName } = useApp();
  const { trackViewedFeatureGate } = useSubscriptionTracking();

  useEffect(() => {
    trackViewedFeatureGate({ feature: Feature.goals });
  }, []);

  const baseClassName = 'FreePlanGoalsContent';

  return (
    <div className={baseClassName}>
      <EmptyStateContainer
        title="Smart goal setting, in one convenient place"
        subTitle="Perform helps you set goals and OKRs that are flexible, measurable, and manageable, so you can drive results."
        button={
          <WpButton dataAttributes={{ 'data-intercom': intercomContactSalesEventName }}>Schedule a call</WpButton>
        }
        image={Illustrations.helping_hand_climbing_mountain_white_bg}
      />
    </div>
  );
};

export default FreePlanGoalsContent;
